.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  max-width: 56rem;

  p {
    line-height: 2.4rem;
  }
}

.server-error-message {
  display: flex;
  justify-content: start;
  margin-top: -3rem;
  margin-bottom: 2rem;
  max-width: 100%;

  & > div {
    max-width: 32rem;
  }
}
